import React from 'react';
import SearchIcon from 'mdi-react/MagnifyIcon';
import { Spinner } from 'src/components/spinner';
import * as S from './styles';

type SearchProps = {
  className?: string;
  inputValue: string;
  onChange: (value: string) => void;
  onFocus: (value: string) => void;
  onBlur?: () => void;
  onSearch: (search: string) => void;
  hasResults?: boolean;
  placeholder?: string;
  setInputValue: (input: string) => void;
  isSearching?: boolean;
};

const Search = ({
  className,
  inputValue,
  onChange,
  onFocus,
  onBlur,
  onSearch,
  hasResults,
  placeholder,
  setInputValue,
  isSearching,
}: SearchProps) => {
  const clearInput = React.useCallback(() => {
    onChange('');
    setInputValue('');
  }, [onChange, setInputValue]);

  const onSearchButtonClick = React.useCallback(() => {
    onSearch(inputValue);
  }, [onSearch, inputValue]);

  const onInputChange: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => void = React.useCallback(
    ({ target }) => {
      onChange(target.value);
      setInputValue(target.value);
    },
    [onChange, setInputValue]
  );

  const handleFocus = React.useCallback(
    e => {
      onFocus(e.target.value);
    },
    [onFocus]
  );

  return (
    <S.Block hasResults={hasResults} className={className}>
      <S.Input
        onChange={onInputChange}
        type="text"
        value={inputValue}
        placeholder={placeholder}
        onFocus={handleFocus}
        onBlur={onBlur}
      />
      <S.ClearButton type="button" visible={inputValue} onClick={clearInput}>
        <S.CloseIcon size={20} />
      </S.ClearButton>
      <S.FullSearchButton type="button" onClick={onSearchButtonClick}>
        {isSearching ? (
          <Spinner isActive={isSearching} position="none" />
        ) : (
          <SearchIcon />
        )}
      </S.FullSearchButton>
    </S.Block>
  );
};

Search.defaultProps = {
  onChange: () => {},
  onFocus: () => {},
  onSearch: () => {},
  hasResults: false,
  placeholder: undefined,
};

export default Search;
